<template>
  <van-tabbar v-model="active" active-color="#87E2CD" class="active_tab">
    <van-tabbar-item
      v-for="(item,index) in tarbars"
      :key="index"
      @click="tab(index,item.name)"
    >
      <span :class="currIndex == index ? active:''">{{item.title}}</span>
      <template slot="icon" slot-scope="props">
        <img :src="props.active ? item.active : item.inactive">
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant';
export default {
  components: {[Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem},
  data(){
    return{
        currIndex: 0,
        tarbars:[
            {title:'首页',name: "index", active:require("../assets/images/home-active.png"),inactive:require("../assets/images/home-inactive.png")},
            {title:'成长报告',name: "report",active:require("../assets/images/report-active.png"),inactive:require("../assets/images/report-inactive.png")},
            {title:'我的',name: "mine",active:require("../assets/images/my-active.png"),inactive:require("../assets/images/my-inactvie.png")},
        ]
    }
  },

  computed: {
    active:{
      get(){
        if(this.$route.path=='/index'){
          return 0
        }else if(this.$route.path=='/report'){
          return 1

        }else if(this.$route.path=='/mine'){
          return 2
        }
      },
      set(){
        if(this.$route.path=='/index'){
          return 0
        }else if(this.$route.path=='/report'){
          return 1

        }else if(this.$route.path=='/mine'){
          return 2
        }
      }
      
    }
  },
  watch: {
  },
  methods: {
    tab(index, val) {
      if(this.$route.path != '/'+val){
        this.$router.push(val);
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
.active_tab img {
  width: 22px;
  height: 22px;
}
</style>